// API base — DO App Platform "infill-patient-case-api-prod".
// Frontend base — DO Spaces CDN endpoint serving the admin SPA.
const apiBase = "https://infill-patient-case-api-prod-9c8dm.ondigitalocean.app/api/v1";
const frontendBase = "https://infill-patient-case-tool-prod-wzbw9.ondigitalocean.app";

export const environment = {
    production: true,
    logErrorInConsole: false,
    environmentName: "production",
    version: require("../../package.json").version,
    httpRequestTimeoutSeconds: 120,
    utcDateFormat: "yyyy-MM-dd HH:mm:ss",
    frontedAppUrl: `${frontendBase}/`,
    oauthBaseAPI: `${apiBase}/auth/`,
    usersAPI: `${apiBase}/users/`,
    rolesAPI: `${apiBase}/roles/`,
    organizationsAPI: `${apiBase}/organizations/`,
    profileAPI: `${apiBase}/profile/`,
    resetPasswordAPI: `${apiBase}/resetpassword/`,
    languagesAPI: `${apiBase}/languages/`,
    smtpMailAccountsAPI: `${apiBase}/mailaccounts/`,
    mailtemplatesAPI: `${apiBase}/mailtemplates/`,
    systemLogMessagesAPI: `${apiBase}/systemlogs/`,
    systemJobPerformancesAPI: `${apiBase}/systemjobs/`,
    systemErrorsAPI: `${apiBase}/systemerrors/`,
    patientCasesAPI: `${apiBase}/patientcases/`
};
